// extracted by mini-css-extract-plugin
module.exports = {"loader":"folksLoader_loader__1iSKC","spinner":"folksLoader_spinner__xF1mf","spin":"folksLoader_spin__2VHjn"};